import { ReactNode, useEffect } from 'react';
import { QUIZ_ANALYTIC_EVENTS } from '@packages/shared/core/analytics/events';
import { useRouter, useServices } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { ProcessingWithPopupStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type ProcessingWithPopupQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ProcessingWithPopupQuizStep = ({ id, renderQuizScreen }: ProcessingWithPopupQuizStepProps) => {
  const { logger, analyticsService } = useServices();
  const { next, back, stepData, updateUserPreferences } = useQuizStep(id);
  const router = useRouter();
  const { date } = router.query;

  useEffect(() => {
    if (!date) {
      return;
    }

    updateUserPreferences('date', date);
    // Disabled since updateUserPreferences causes an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const onPopupOpen = (event: QUIZ_ANALYTIC_EVENTS) => {
    analyticsService.trackQuizEvent(event, {});
  };
  const onPopupClick = (event: QUIZ_ANALYTIC_EVENTS, choice: string) => {
    analyticsService.trackQuizEvent(event, { context: choice });
  };

  const onProcessingWithPopupFinished = async () => next();
  const goBack = async () => back();

  return (
    <>
      {renderQuizScreen({
        onPopupOpen,
        onPopupClick,
        onBack: goBack,
        onFinished: onProcessingWithPopupFinished,
        ...(stepData as ProcessingWithPopupStepData),
      })}
    </>
  );
};

export default ProcessingWithPopupQuizStep;
